
// import useSWR from 'swr';
import axios, { AxiosResponse } from 'axios';
import { useEffect, useState } from 'react';
import { Application } from '../../../../api/ApiEntreprise';

const API_BASE_URL = import.meta.env.VITE_API;

// const fetcher = (url: string) => axios.get(url, {
//   headers: {
//     Authorization: `Bearer ${localStorage.getItem('access_token')}`,
//   },
// }).then(res => res.data.data);

export default function useApplicationUsers(companyId: number, applications: Array<Application>) {
  const [numberUsers, setNumberUsers] = useState(0);
  const [usersByApplication, setUsersByApplication] = useState<Record<number, number>>({});

  useEffect(() => {
    // let totalUsers = 0;
    const usersPerApp: Record<number, number> = {};

    Promise.all(
      applications.map(async app => {
        try {
          const userList = await axios.get<AxiosResponse<Array<any>>>(
            `${API_BASE_URL}/Company/${companyId}/applications/${app.id}/users`, 
            {
            withCredentials:true,
              // headers: {
              //   Authorization: `Bearer ${localStorage.getItem('access_token')}`,
              // },
            }
          ).then(res => res.data.data);

          const count = userList.length;
          usersPerApp[app.id] = count;
          return count;
        } catch (error) {
          console.error(`Error fetching users for app ${app.id}:`, error);
          usersPerApp[app.id] = 0;
          return 0;
        }
      })
    ).then(counts => {
      const sum = counts.reduce((acc, count) => acc + count, 0);
      setNumberUsers(sum);
      setUsersByApplication(usersPerApp);
    });
  }, [applications, companyId]);

  return {
    users: numberUsers,
    usersByApplication,
    isLoading: numberUsers < 0 && applications.length > 0,
    
  };
}
// import useSWR from 'swr';
// import axios, { AxiosResponse } from 'axios';
// import { useEffect, useState } from 'react';
// import { Application } from '../ApiEntreprise';

// const API_BASE_URL = import.meta.env.VITE_API;

// const fetcher = (url: string) => axios.get(url, {
//   headers: {
//     Authorization: `Bearer ${localStorage.getItem('access_token')}`,
//   },
// }).then(res => res.data.data);

// export const getuserlenghtapp = (companyId: number, appId : number) => {
//   const { data } =  useSWR<Array<any>>(
//     `${API_BASE_URL}/Company/${companyId}/applications/${appId}/users`,
//     fetcher
//   );
//   return data;
// }

// export default function useApplicationUsers (companyId: number, applications: Array<Application>) {
  
//   const [numberUsers, setNumberUsers] = useState(0);
//   useEffect(()=>{
//     let totalUsers= 0;

//     Promise.all(
//       applications.map(async app => {
//         // const { data } =  useSWR<Array<any>>(
//         //   `${API_BASE_URL}/Company/${companyId}/applications/${app.id}/users`,
//         //   fetcher
//         // );
//         const userList = await axios.get<AxiosResponse<Array<any>>>(`${API_BASE_URL}/Company/${companyId}/applications/${app.id}/users`, {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem('access_token')}`,
//           },
//         }).then(res => {return res.data.data});
//         // const data  = getuserlenghtapp(companyId, app.id)
//         console.log("userlist", userList)
//         //  totalUsers +=  userList.length
//          console.log("totaluserapp", totalUsers)
//         //  setNumberUsers(totalUsers)
//           return userList.length;
//           // totalUsers += users; // Accédez à la propriété `count` si `users` est un objet
//       })
//   ).then(
//     counts => {
//       const sum = counts.reduce((acc, count) =>acc + count, 0
//        )
//       console.log("counts", counts)
//       setNumberUsers(sum);
//     }
//   );
  
//   }, [applications])
  

//   return {
//     users: numberUsers,
//     // isLoading,
//     // isError: error,
//   };
// };